import React, { useState, useContext, useEffect } from "react";
import { Container } from "@mui/material";
import styles from "./styles";
import TopicContainer from "../TopicContainer";
import { HashContext } from "context/hash-context";

function PagesContainer({ pages }) {
  const [elements, setElements] = useState([]);
  const routeId = useContext(HashContext);

  if (pages.length && !elements.length) {
    const newElements = [];

    const getTopicContainer = ({
      page,
      anchorTag,
      pageRef,
      menuRef,
      examples,
    }) => (
      <TopicContainer
        key={anchorTag}
        anchorTag={anchorTag}
        pageRef={pageRef}
        menuRef={menuRef}
        page={page}
        examples={examples}
      />
    );

    pages.forEach(({ items }) => {
      items.forEach((topic) => {
        newElements.push(getTopicContainer(topic));

        topic.subtopics.forEach((subtopic) => {
          newElements.push(getTopicContainer(subtopic));
        });
      });
    });

    setElements(newElements);
  }

  // Scroll to topic when hash changes and content is loaded
  useEffect(() => {
    if (routeId) {
      // Function to find the topic container with id to scroll
      const scrollToElement = () => {
        const contentElement = document.getElementById(`${routeId}-container`);
        if (contentElement) {
          contentElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

      // Execute the scroll after a short delay
      setTimeout(scrollToElement, 1000);
    }
  }, [routeId]);

  return (
    <Container disableGutters sx={styles}>
      {elements}
    </Container>
  );
}

export default PagesContainer;
